import React, {useEffect, useState} from "react";
import {isBrowser, isMobile} from "react-device-detect";
import {useDispatch, useSelector} from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import LargeModal from "../../../../components/modals/LargeModal";
import {closePharmacyOrderAcceptModal} from "../../../../redux/actions/modals";
import {acceptPharmacyOrder} from "../../../../redux/actions/orders";
import toaster from "../../../../utils/toaster";
import CharsUtil from "./../../../../utils/characters.js";

const PharmacyOrderAcceptComponent = (props) => {
    const dispatch = useDispatch();
    const {
        pharmacy_order_accept_open,
        pharmacy_order_accept_order,
        pharmacy_order_accept_type,
    } = useSelector((state) => state.modals);
    const [hasInsurance, setHasInsurance] = useState(false);
    const [needPrepare, setNeedPrepare] = useState(false);
    const [pervProps, setPervProps] = useState({order: undefined});
    const [prices, setPrices] = useState({
        price: "",
        insurance: "",
    });
    const {accept_pharmacy_order_waiting} = useSelector(
        (state) => state.orders
    );
    const orderAccept = () => {
        let hardCopy = pharmacy_order_accept_type !== "simple";
        let data = {
            force_return: pharmacy_order_accept_type === "special",
            has_insurance: hasInsurance || pharmacy_order_accept_type === "insurance",
            needToPrepare: needPrepare,
            regular_price: prices.price.toString().replace(/[, ]+/g, "").trim(),
            insurance_price: prices.insurance.toString().replace(/[, ]+/g, "").trim(),
            id: pharmacy_order_accept_order.id,
        };
        if (
            data.regular_price === 0 ||
            data.regular_price === "" ||
            data.regular_price === "0"
        ) {
            toaster.error("هزینه نسخه بدون بیمه حتما باید وارد شود.");
            return;
        }

        if (
            data.has_insurance &&
            (data.insurance_price === 0 ||
                data.insurance_price === "" ||
                data.insurance_price === "0")
        ) {
            toaster.error("هزینه نسخه با بیمه در این حالت باید وارد شود.");
            return;
        }
        if (parseInt(data.regular_price) < parseInt(data.insurance_price)) {
            toaster.error("هزینه نسخه بدون بیمه نباید از هزینه با بیمه کمتر باشد.");
            return;
        }

        dispatch(acceptPharmacyOrder(data));
    };

    useEffect(() => {
        if (pervProps.order === props.order) {
            return;
        }
        setPrices({
            price: "",
            insurance: "",
        });
        setPervProps(props);
    }, [props]);
    const checkInput = (char) => {
        let reg = new RegExp("^[0-9,۰-۹]+$");
        return reg.test(char.trim().replace(",", ""));
    };

    const close = () =>{
        setNeedPrepare(false)
        setHasInsurance(false)
        setPrices({
            price: "",
            insurance: "",
        });
    }
    return (
        <>
            <LargeModal
                header="تایید سفارش"
                show={pharmacy_order_accept_open}
                closeFunction={() => {
                    close();
                    return closePharmacyOrderAcceptModal();
                }}
            >
                <div className="pharmacy-accept-form-holder">
                    <div className="prepare-view">
                        {pharmacy_order_accept_type === "special" ? (
                            <div className="row form-item col-lg-4">
                                <input
                                    type="checkbox"
                                    name={"has-insurance"}
                                    id={"has-insurance"}
                                    checked={hasInsurance === true}
                                    value={"hasInsurance"}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === "hasInsurance") {
                                            setHasInsurance(!hasInsurance);
                                        }
                                    }}
                                />
                                <label
                                    className={isBrowser ? "col-lg-11 col-form-label" : ""}
                                    htmlFor="has-insurance"
                                    style={
                                        isBrowser
                                            ? {textAlign: "right"}
                                            : {
                                                width: "80%",
                                                textAlign: "right",
                                                marginRight: "15px",
                                                marginBottom: "0px",
                                            }
                                    }
                                >
                                    دارو بیمه دارد
                                </label>
                            </div>
                        ) : null}

                        <div className="row form-item col-lg-7">
                            <input
                                type="checkbox"
                                name={"need-prepare"}
                                id={"need-prepare"}
                                checked={needPrepare === true}
                                value={'needPrepare'}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === 'needPrepare') {
                                        setNeedPrepare(!needPrepare);
                                    }
                                }}
                            />
                            <label className={isBrowser ? "col-lg-11 col-form-label" : ""} htmlFor="need-prepare"
                                   style={isBrowser ? {textAlign: 'right'} : {
                                       width: '80%',
                                       textAlign: 'right',
                                       marginRight: '15px',
                                       marginBottom: '0px'
                                   }}>دارو نیاز به آماده‌سازی دارد ( امکان ارسال سریع وجود ندارد )</label>
                        </div>
                    </div>

                    <div className="row form-item">
                        <label
                            className="col-lg-3 col-form-label"
                            htmlFor="regular-price"
                            style={{textAlign: "right"}}
                        >
                            هزینه بدون بیمه (تومان)
                        </label>
                        <input
                            type="text"
                            id="regular-price"
                            className="col-lg-9 form-control"
                            value={prices.price}
                            onChange={(e) => {
                                if (
                                    checkInput(e.target.value) ||
                                    e.target.value.trim() === ""
                                ) {
                                    let regular_price = CharsUtil.FaToEn(
                                        e.target.value.toString()
                                    );
                                    regular_price = regular_price
                                        .replace(new RegExp(",", "g"), "")
                                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                    setPrices((prevState) => ({
                                        ...prevState,
                                        price: regular_price,
                                    }));
                                } else {
                                    toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                                }
                            }}
                        />
                    </div>
                    {pharmacy_order_accept_type === "insurance" || hasInsurance ? (
                        <div className="row form-item">
                            <label
                                className="col-lg-3 col-form-label"
                                htmlFor="insurance-price"
                                style={{textAlign: "right"}}
                            >
                                هزینه با بیمه (تومان)
                            </label>
                            <input
                                type="text"
                                id="insurance-price"
                                className="col-lg-9 form-control"
                                value={prices.insurance}
                                onChange={(e) => {
                                    if (
                                        checkInput(e.target.value) ||
                                        e.target.value.trim() === ""
                                    ) {
                                        let price = CharsUtil.FaToEn(e.target.value.toString());
                                        price = price
                                            .toString()
                                            .replace(new RegExp(",", "g"), "")
                                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                        setPrices((prevState) => ({
                                            ...prevState,
                                            insurance: price,
                                        }));
                                    } else {
                                        toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                                    }
                                }}
                            />
                        </div>
                    ) : null}
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <CustomButton
                            className="btn btn-success text-white"
                            action={() => {
                                orderAccept();
                                setPrices({
                                    price: "",
                                    insurance: "",
                                });
                            }}
                            loading={accept_pharmacy_order_waiting}
                            content={"تایید سفارش"}
                            type={"success"}
                            textWhite={true}
                            block={true}
                            style={isMobile ? {fontSize: "12px"} : {}}
                        />
                        <button
                            className="btn btn-outline-dark"
                            style={
                                isMobile
                                    ? {fontSize: "12px", marginRight: "10px"}
                                    : {marginRight: "10px"}
                            }
                            onClick={() => {
                                close();
                                dispatch(closePharmacyOrderAcceptModal());
                                setPrices({
                                    price: "",
                                    insurance: "",
                                });
                            }}
                        >
                            انصراف
                        </button>
                    </div>
                </div>
            </LargeModal>
        </>
    );
};
export default PharmacyOrderAcceptComponent;
